// ClientsGrid.jsx
import React, { useEffect, useRef } from "react";
import "./Clients2.css";
import logo from "../Imges/logo.png";

// Import client images
import clientImage1 from "../Imges/Client-1.jpg";
import clientImage2 from "../Imges/Client-2.jpg";
import clientImage3 from "../Imges/Client-3.jpg";
import clientImage4 from "../Imges/Client-4.jpg";
import clientImage5 from "../Imges/Client-5.jpg";
import clientImage6 from "../Imges/Client-6.jpg";
import clientImage7 from "../Imges/Client-7.jpg";
import clientImage8 from "../Imges/Client-8.jpg";
import clientImage9 from "../Imges/Client-9.jpg";
import clientImage10 from "../Imges/Client-10.jpg";
import clientImage11 from "../Imges/Client-11.jpg";
import clientImage12 from "../Imges/Client-12.jpg";
import clientImage13 from "../Imges/Client-13.jpg";
import clientImage14 from "../Imges/Client-14.jpg";
import clientImage15 from "../Imges/Client-15.jpg";
import clientImage16 from "../Imges/Client-16.jpg";
import clientImage17 from "../Imges/Client-17.jpg";
import clientImage18 from "../Imges/Client-18.jpg";
import clientImage19 from "../Imges/Client-19.jpg";
import clientImage20 from "../Imges/Client-20.jpg";
import clientImage21 from "../Imges/Client-21.jpg";
import clientImage22 from "../Imges/Client-22.jpg";
import clientImage23 from "../Imges/Client-23.jpg";
import clientImage24 from "../Imges/Client-24.jpg";
import clientImage25 from "../Imges/Client-25.jpg";
import clientImage26 from "../Imges/Logos/c-1.jpg";
import clientImage27 from "../Imges/Logos/c-2.png";
import clientImage28 from "../Imges/Logos/c-3.png";
import clientImage29 from "../Imges/Logos/c-4.png";
import clientImage30 from "../Imges/Logos/c-5.png";
import clientImage31 from "../Imges/Logos/c-6.png";
import clientImage32 from "../Imges/Logos/c-7.png";
import clientImage33 from "../Imges/Logos/c-8.png";
import clientImage34 from "../Imges/Logos/c-9.png";
import clientImage35 from "../Imges/Logos/c-10.png";
import clientImage36 from "../Imges/Logos/c-11.png";
import clientImage37 from "../Imges/Logos/c-12.png";
import clientImage38 from "../Imges/Logos/c-13.png";
import clientImage39 from "../Imges/Logos/c-14.png";
import clientImage40 from "../Imges/Logos/c-15.png";
import clientImage41 from "../Imges/Logos/c-16.png";
import clientImage42 from "../Imges/Logos/c-17.png";
import clientImage43 from "../Imges/Logos/c-18.png";
import clientImage44 from "../Imges/Logos/c-19.png";
import clientImage45 from "../Imges/Logos/c-20.png";
import clientImage46 from "../Imges/Logos/c-21.png";
import clientImage47 from "../Imges/Logos/c-22.png";
import clientImage48 from "../Imges/Logos/c-23.png";
import clientImage49 from "../Imges/Logos/c-24.png";
import clientImage50 from "../Imges/Logos/c-25.png";
import clientImage51 from "../Imges/Logos/c-26.png";
import clientImage52 from "../Imges/Logos/c-27.png";
import clientImage53 from "../Imges/Logos/c-28.png";

const clients = [
  { id: 1, img: clientImage1 },
  { id: 2, img: clientImage2 },
  { id: 3, img: clientImage3 },
  { id: 4, img: clientImage4 },
  { id: 5, img: clientImage5 },
  { id: 6, img: clientImage6 },
  { id: 7, img: clientImage7 },
  { id: 8, img: clientImage8 },
  { id: 9, img: clientImage9 },
  { id: 10, img: clientImage10 },
  { id: 11, img: clientImage11 },
  { id: 12, img: clientImage12 },
  { id: 13, img: clientImage13 },
  { id: 14, img: clientImage14 },
  { id: 15, img: clientImage15 },
  { id: 16, img: clientImage16 },
  { id: 17, img: clientImage17 },
  { id: 18, img: clientImage18 },
  { id: 19, img: clientImage19 },
  { id: 20, img: clientImage20 },
  { id: 21, img: clientImage21 },
  { id: 22, img: clientImage22 },
  { id: 23, img: clientImage23 },
  { id: 24, img: clientImage24 },
  { id: 25, img: clientImage25 },
  { id: 26, img: clientImage26 },
  { id: 27, img: clientImage27 },
  { id: 28, img: clientImage28 },
  { id: 29, img: clientImage29 },
  { id: 30, img: clientImage30 },
  { id: 31, img: clientImage31 },
  { id: 32, img: clientImage32 },
  { id: 33, img: clientImage33 },
  { id: 34, img: clientImage34 },
  { id: 35, img: clientImage35 },
  { id: 36, img: clientImage36 },
  { id: 37, img: clientImage37 },
  { id: 38, img: clientImage38 },
  { id: 39, img: clientImage39 },
  { id: 40, img: clientImage40 },
  { id: 41, img: clientImage41 },
  { id: 42, img: clientImage42 },
  { id: 43, img: clientImage43 },
  { id: 44, img: clientImage44 },
  { id: 45, img: clientImage45 },
  { id: 46, img: clientImage46 },
  { id: 47, img: clientImage47 },
  { id: 48, img: clientImage48 },
  { id: 49, img: clientImage49 },
  { id: 50, img: clientImage50 },
  { id: 51, img: clientImage51 },
  { id: 52, img: clientImage52 },
  { id: 53, img: clientImage53 },
];

const ClientsGrid = () => {
  const gridRefs = useRef([]);

  useEffect(() => {
    const handleScroll = () => {
      gridRefs.current.forEach((item) => {
        if (item) {
          const rect = item.getBoundingClientRect();
          if (rect.top < window.innerHeight - 50 && rect.bottom > 50) {
            item.classList.add("visible");
          } else {
            item.classList.remove("visible");
          }
        }
      });
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="clients-container">
      <h1>
        <img
          src={logo}
          alt="Company Logo"
          className="logo"
          style={{ marginTop: "20%", maxWidth: "50%" }}
        />
      </h1>
      <p className="tagline">" We make every customer feel like a VIP "</p>

      <div className="grid-container">
        {clients.map((client, index) => (
          <div
            key={client.id}
            ref={(el) => (gridRefs.current[index] = el)}
            className="grid-item"
          >
            <img src={client.img} alt={`Client ${client.id}`} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ClientsGrid;